import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Animate from "react-smooth/lib/Animate";
import LottieComponent from "./lottieComponent";
import PropTypes from "prop-types";
import { handleLoader } from "../utils/handlerProduct";
import { getTheme } from "../themes/themeManager";
import { THEME_PROPERTIES } from "../themes/themes.consts";
import Zoom from "react-reveal/Zoom";

const LoaderComponent = (props) => {
    const [showLoader, setShowLoader] = useState(true);
    const [loaderType] = useState(getTheme(THEME_PROPERTIES.LOADER_TYPE));

    useEffect(() => {
        return () => {
            setShowLoader(false);
        };
    }, []);

    return (
        <>
            {loaderType === "CUSTOM" ? (
                <Zoom when={showLoader}>
                    <CustomLoader style={{ backgroundImage: `url("${getTheme(THEME_PROPERTIES.LOADER)}")` }} />
                </Zoom>
            ) : loaderType === "LOGO" ? (
                <LogoLoader style={{ backgroundColor: getTheme(THEME_PROPERTIES.COLOR) }}>
                    <img src={getTheme(THEME_PROPERTIES.LOADER)} alt="logo-loader" />
                </LogoLoader>
            ) : (
                <Animate to="1" from="0" duration={500} attributeName="opacity">
                    <LoaderContainer style={{ backgroundColor: props.settings && props.settings.darkMode === true ? "#18191a" : "#f6f6f6" }}>
                        <LottieComponent animation={handleLoader()} loop={true} autoplay={true} height={400} width={400} />
                    </LoaderContainer>
                    <Logo src={require("../assets/logo-full.png")} />
                </Animate>
            )}
        </>
    );
};

LoaderComponent.propTypes = {
    settings: PropTypes.object,
};

const Logo = styled.img`
    position: fixed;
    width: 100px;
    bottom: 40px;
    margin-right: auto;
    margin-left: auto;
    left: 0;
    right: 0;
    opacity: 0.7;
    margin-top: 15%;
    z-index: 9999999999;
`;

const CustomLoader = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9999999999;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    @media (min-width: 1000px) {
        background-size: contain;
    }
`;

const LogoLoader = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9999999999;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;

    @media (min-width: 1000px) {
        background-size: contain;
    }

    img {
        position: absolute;
        top: 40%;
        width: 200px;
        animation: pulse 1.5s infinite;
    }

    @keyframes pulse {
        0% {
          transform: scale(1);
          opacity: 0.1
        }
        50% {
          transform: scale(1.1);
          opacity: 1
        }
        100% {
          transform: scale(1);
          opacity: 0.1
        }
      }


`;

const LoaderContainer = styled.div`
    height: 300px;
    background-color: red;
    height: 100%;
    position: fixed;
    margin-right: auto;
    margin-left: auto;
    left: 0;
    right: 0;
    top: 0%;
    z-index: 999999;

    div {
        @media (max-width: 1000px) {
            width: 100% !important;
        }
    }

    svg {
        padding: 80px;
        g {
            g {
                g {
                    g:nth-child(1),
                    g:nth-child(2),
                    g:nth-child(4),
                    g:nth-child(5) {
                        path {
                            fill: orange;
                        }
                    }
                }
            }
        }
    }

    h1 {
        text-align: center;
        font-size: 1.1em;
        position: absolute;
        width: 100%;
        top: 104%;
        margin-left: 5px;
        font-weight: 600;
    }
`;

export default LoaderComponent;
